// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 8 7", width: "8", height: "7" }, props),
        React.createElement(React.Fragment, null,
            React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
                React.createElement("g", null,
                    React.createElement("g", { transform: "translate(-56 -101) translate(56 101)" },
                        React.createElement("path", { d: "M3.4693 0 3.9985 1.2247 1.7463 3.5002 4 5.774 3.4697 7 0 3.5002z" }),
                        React.createElement("path", { d: "M2 3H8V4H2z" })))))));
};
Icon.displayName = 'ArrowLeft8x7';
export default Icon;
//# sourceMappingURL=ArrowLeft8x7.js.map